import { createContext } from "react";

const promoContext = createContext();

export default promoContext;
